module.exports = __webpack_public_path__ + "6b6d24175e2acbbce78f49a48ef15884.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/group_placeholder.png
// module id = 696
// module chunks = 0